import type { FallbackProps } from 'react-error-boundary';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { config } from '@/config/env';

export default function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const message = error instanceof Error ? error.message : String(error);
  return (
    <Box
      role="alert"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        p: 3,
      }}
    >
      <Paper elevation={3} sx={{ p: 4, maxWidth: 480, width: '100%', textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Something went wrong
        </Typography>

        {!config.isProd && (
          <Typography
            variant="body2"
            color="error"
            sx={{
              mt: 1,
              mb: 3,
              fontFamily: 'monospace',
              textAlign: 'left',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
          >
            {message}
          </Typography>
        )}

        <Button variant="contained" onClick={resetErrorBoundary}>
          Try again
        </Button>
      </Paper>
    </Box>
  );
}
